"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Returns a new display name for a Component combining the Base Component name with the name of the HOC.

function wrapDisplayName(BaseComponent, hocName) {
  return "".concat(hocName, "(").concat(getDisplayName(BaseComponent), ")");
}

// Helper

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }
  if (!Component) {
    return undefined;
  }
  return Component.displayName || Component.name || 'Component';
}
var _default = wrapDisplayName;
exports["default"] = _default;